import React, { Component } from 'react';
import IntlMessages from '../../helpers/IntlMessages';
import moment from 'moment';

import AlertCard from './AlertCard';
import { injectIntl } from 'react-intl';

class CarCard extends Component {
  // Render
  render() {
    const {
      reservation,
      order,
      intl: { messages },
    } = this.props;

    return (
      <div className="item" data-testid={order.id}>
        <div className="date">
          <div className="content">
            <span className="day">
              {moment(reservation.carDetails.pickUp, 'DD/MM/YYYY HH:mm').format(
                'DD'
              )}
            </span>
            <span className="month">
              {moment(reservation.carDetails.pickUp, 'DD/MM/YYYY HH:mm').format(
                'MMM'
              )}
            </span>
          </div>
        </div>
        <div
          className="details"
          onClick={() => {
            this.props.openCar(reservation);
          }}
        >
          <div className="details-content car">
            <div className="gradient">
              <div className="header">
                <div className="img" />
                <div>
                  <span>
                    <IntlMessages id="travel.car" />
                  </span>
                  {reservation.carDetails.name}
                </div>
              </div>

              <div className="route clearfix">
                <div className="airport">
                  <span>
                    <IntlMessages id="travel.car.pickup" />
                  </span>
                  {moment(
                    reservation.carDetails.pickUp,
                    'DD/MM/YYYY HH:mm'
                  ).format('DD/MM')}
                </div>
                <div className="to text-center">
                  <img
                    src="/assets/img/icons/timeline_car_white.svg"
                    alt={messages['alts.components.timeline.car-card']}
                  />
                </div>
                <div className="airport text-right">
                  <span>
                    <IntlMessages id="travel.car.dropoff" />
                  </span>
                  {moment(
                    reservation.carDetails.dropOff,
                    'DD/MM/YYYY HH:mm'
                  ).format('DD/MM')}
                </div>
              </div>
            </div>
          </div>

          <AlertCard order={order} />
        </div>
      </div>
    );
  }
}

export default injectIntl(CarCard);
